import { ApiClientAxios as Axios } from "@repo/api";
import { useCallback } from "react";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";

export const useContributionTypeFormatter = () => {
    const { t } = useTypedTranslation();

    return useCallback(
        (contractContributionType: Axios.FufiContributionType) => {
            switch (contractContributionType) {
                case Axios.FufiContributionType.Employee:
                    return t("fufi.paymentOverviewTable.contributionTypes.Employee");
                case Axios.FufiContributionType.Employer:
                    return t("fufi.paymentOverviewTable.contributionTypes.Employer");
                default:
                    return t("fufi.paymentOverviewTable.contributionTypes.Unknown");
            }
        },
        [t],
    );
};

export const usePaymentTypeFormatter = () => {
    const { t } = useTypedTranslation();

    return useCallback(
        (paymentType: Axios.FufiPaymentType) => {
            switch (paymentType) {
                case Axios.FufiPaymentType.Normal:
                    return t("fufi.paymentOverviewTable.paymentTypes.Normal");
                case Axios.FufiPaymentType.Unsolicited:
                    return t("fufi.paymentOverviewTable.paymentTypes.Unsolicited");
                case Axios.FufiPaymentType.Unsolved:
                    return t("fufi.paymentOverviewTable.paymentTypes.Unsolved");
                default:
                    return t("fufi.paymentOverviewTable.paymentTypes.Unknown");
            }
        },
        [t],
    );
};
